import { render, staticRenderFns } from "./CandidatePersonalLink.vue?vue&type=template&id=408a3ed8&"
import script from "./CandidatePersonalLink.vue?vue&type=script&lang=js&"
export * from "./CandidatePersonalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports